import { MuteMotionSource } from 'motion/MuteMotionSource';
import * as React from 'react';
import { drawMotionSource } from '../utils';

interface Props {
  width: number;
  height: number;
  motionSource: MuteMotionSource;
}

export class MotionView extends React.Component<Props> {
  canvas = React.createRef<HTMLCanvasElement>();
  pastMotionData: string;

  componentDidMount() {
    this.updateWave();
    this.pastMotionData = JSON.stringify(this.props.motionSource.asData());
  }

  componentDidUpdate(prevProps: Props) {
    const { width, height, motionSource } = this.props;
    const motionData = JSON.stringify(motionSource.asData());
    if (
      motionData !== this.pastMotionData ||
      prevProps.width !== width ||
      prevProps.height !== height
    ) {
      this.updateWave();
      this.pastMotionData = motionData;
    }
  }

  updateWave() {
    if (!this.canvas.current) {
      return;
    }
    const ctx = this.canvas.current.getContext('2d');
    if (ctx) {
      drawMotionSource(
        ctx,
        this.props.motionSource,
        this.props.width,
        this.props.height
      );
    }
  }
  render() {
    return (
      <canvas
        width={this.props.width}
        height={this.props.height}
        ref={this.canvas}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/components/MotionView.tsx